/**
* Edit mode list for object
* @type {{idle: number, rotate: number, scale: number, drag: number, delete: number}}
*/

import { Entity, math, Wall } from "@rhinov/savane-js";
import { BenchTimer } from "../../utils/BenchTimer";

export const EditModeEnum =
    {
        idle: 0,
        rotate: 1,
        drag: 2,
        delete: 3,
        resizeH: 4,
        resizeV: 5,
        inclinaison: 6
    };

 export const ActionStateEnum =
    {
        idleCreate: 0,
        idleMultipleCreates: 1,
        createWall: 2,
        createMultipleWalls: 3,
        idleEdit: 4,
        editPoint: 5,
        editWall: 6,
        addJoinery: 7,
        editJoinery: 8,
        addRoom: 9,

        EditCote: 13,

        idleVisualise: 14,

        MoveFunctionalityChipState: 15,
        AddTechnicalElement: 16,
        EditTechnicalElement: 17,
        MoveTechnicalElement: 18,
        AddStaircase: 19,
        EditStaircase: 20,
        Quotation: 23,
        SelectedOrderRoom: 24,

        idleCamera: 25,
        AbsoluteIdle: 26,

        idleDecoration: 30,

        AddEntity: 31,
        EditEntity: 32,
        EditEntities: 43,

        RoomsValidation: 33,
        IdleConstruction: 34,
        idleSmartDesigner: 35,
        DragCoating: 36,
        DrawArea: 37,
        FrontView: 38,
        DrawWorkTop: 39,
        DragComponent: 40,

        FrontViewAddEntity: 41,
        FrontViewCoating: 42,
        FloorCoatingArea: 43,
        FrontViewCutArea: 44,
        FrontViewAddArea: 45,
        FrontViewAddJoinery: 46
    };

export const RoomType =
    {
        square: 0,
        L0: 1,
        L90: 2,
        L180: 3,
        L270: 4
    };

export abstract class ActionState {

    benchActionTool: BenchTimer;
    state: number = 0;

    constructor() {
        this.benchActionTool = new BenchTimer();
    }

    initialize() {

    }
        
    /**
     * Mouse stay still (anywhere)
     * @param cursorPosition
     * @returns {null}
     */
    mouseIdle(cursorPosition: math.vec3, hoverEntities: Array<Entity>, dt: number): ActionState | null {
        return null;
    }

    /**
     * Mouse move inside the scrollWindow
     * @param cursorPosition
     * @returns {null}
     */
    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Array<Entity>, planpos?: math.vec3): ActionState | null {
        return null;
    }

    /**
     * A click end inside the scrollWindow
     * @param cursorPosition
     * @param elapsedTime elapsedTime during touch down in milliseconds
     * @returns {null}
     */

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Array<Entity>, mouseButton: number): ActionState | null {
        return null;
    }

    /**
     * A click start inside the scrollWindow
     * @param cursorPosition
     * @returns {null}
     */
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Array<Entity>, mouseButton: number, removeArea?: boolean): ActionState | null {
        return null;
    }

    /**
     * A click end outside the scrollWindow
     * @param cursorPosition
     * @returns {null}
     */
    mouseClickCancelled(cursorPosition: math.vec3) : ActionState | null {
        return null;
    }

    /**
     * A button from lateral panel has been pressed
     *
     * @param buttonId
     * @returns {Boolean} If return false the button will no change the action state
     */
    onButton(buttonId: number) {
        return true;
    }

    /**
     * The mouse is currently over a wall
     */
    mouseHoverWall(wallHovered: Wall, cursorPosition: math.vec3) {
        return true;
    }

    /**
     * The mouse just get out of a wall
     */
    mouseLeaveHoverWall(wallHovered: Wall, cursorPosition: math.vec3) {
        return true;
    }

    /**
     *
     * A keyboard key is pressed
     * @param keyCode
     * @param ctrl
     * @returns {null}
     */
    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        return null;
    }

    /**
     *
     * A keyboard key is unpressed
     * @param keyCode
     * @returns {null}
     */
    keyUnPressed(keyCod: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        return null;
    }

    isDecorationState() {
        return false;
    }

    isVisualiseState() {
        return false;
    }

    /**
     * A short click
     * @returns {IdleEditState}
     */
    snapClick(): ActionState | null {
        return null;
    }

    // Object destruction
    dispose() {
    }

    getAction() {
        return -1;
    }
}